import React, { createContext, useContext, useMemo, useState } from 'react';

const SignupContext = createContext(null);

export const SignupProvider = ({ children }) => {
  const [state, setState] = useState({
    mobile: '',
    mobileOtp: '',
    otpToken: '',
    otpVerified: false,
    panDetails: null,
    panUploadUrl: '',
    aadhaarRefId: '',
    aadhaarOtp: '',
    aadhaarDetails: null,
    aadhaarUploadUrls: null,
    businessDetails: null,
    businessDocuments: null,
  });

  const updateState = (updates) => {
    setState((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const value = useMemo(
    () => ({
      signupState: state,
      updateSignupState: updateState,
      resetSignup: () =>
        setState({
          mobile: '',
          mobileOtp: '',
          otpToken: '',
          otpVerified: false,
          panDetails: null,
          panUploadUrl: '',
          aadhaarRefId: '',
          aadhaarOtp: '',
          aadhaarDetails: null,
          aadhaarUploadUrls: null,
          businessDetails: null,
          businessDocuments: null,
        }),
    }),
    [state]
  );

  return <SignupContext.Provider value={value}>{children}</SignupContext.Provider>;
};

export const useSignup = () => {
  const context = useContext(SignupContext);

  if (!context) {
    throw new Error('useSignup must be used within SignupProvider');
  }

  return context;
};


